import { Controller } from "@hotwired/stimulus";

// Contrôleur pour gérer l'affichage des filtres d'absences
export default class extends Controller {
  static targets = ["filtersPanel"];

  connect() {
    // Facultatif : masquer les filtres par défaut sur les petits écrans
    if (window.innerWidth < 768) {
      this.hideFilters();
    }
  }

  // Afficher ou masquer les filtres
  toggleFilters() {
    if (this.filtersPanelTarget.classList.contains("hidden")) {
      this.showFilters();
    } else {
      this.hideFilters();
    }
  }

  // Afficher les filtres
  showFilters() {
    this.filtersPanelTarget.classList.remove("hidden");
  }

  // Masquer les filtres
  hideFilters() {
    this.filtersPanelTarget.classList.add("hidden");
  }
}
